import Cookies from 'js-cookie';
import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.Filters;

// initial state
// object name must match specification name
const filters = {
	StateCode: new FormControl.FilterGroup('StateCode', 'State', 'All States', '', false, true, 'checkbox'),
	Zipcode: new FormControl.FilterGroup(
		'Zipcode', 'Zip Code', null, null, false, true, 'textbox',
		new FormControl.Textbox('')
	),
	Radius: new FormControl.FilterGroup('Radius', 'Radius (mi)', null, '25', false, true, 'select'),
	//Study: new FormControl.FilterGroup('Study', 'Study', 'Areas of Study', '', true, false, 'checkbox'),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };